import { useApi } from '@omnipresentgroup/api';
import type {
  BenefitType,
  GetBenefitsResponse,
  GetBenefitsResponseAPI,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, BENEFITS_API_PATH } from '../constants';
import { transformBenefitsFromAPI } from '../mappers';

export type BenefitQueryParameters = {
  employeeId?: string;
  countryCode?: string;
  benefitType?: BenefitType;
  enabled?: boolean;
};

const getBenefitsKey = ({
  employeeId,
  countryCode,
  benefitType,
}: {
  employeeId?: string;
  countryCode?: string;
  benefitType?: BenefitType;
}) => [BENEFITS_API_PATH, employeeId, countryCode, benefitType];

export const useBenefits = ({
  employeeId,
  countryCode,
  benefitType,
  enabled,
}: BenefitQueryParameters) => {
  const { GET } = useApi();

  return useQuery<GetBenefitsResponseAPI, unknown, GetBenefitsResponse>({
    queryKey: getBenefitsKey({
      employeeId,
      countryCode,
      benefitType,
    }),
    queryFn: () =>
      GET<GetBenefitsResponseAPI>(
        `${API_BASE}/${BENEFITS_API_PATH}`,
        {},
        {
          ...(employeeId && { employee_id: employeeId }),
          ...(countryCode && { country_code: countryCode }),
          ...(benefitType && { benefit_type: benefitType }),
        },
      ),
    select: transformBenefitsFromAPI,
    enabled: enabled,
  });
};
